<template>
    <div id="app">
        <div class="pc-box">
            <Header/>
            <Banner/>
            <div class="content">
                <div class="content-left">
                    <router-view/>
                </div>
                <div class="content-right">
                    <ContentR/>
                </div>
            </div>
            <Suspension/>
            <Footer/>
            <Mobile/>
        </div>

        <div v-if="popup" class="popup-bg">
            <div class="popup-box">
                <a href="http://www.ctbmall.com/"  target="_blank">
                    <img :src="require('@/assets/ctb.gif')">
                </a>

                <i class="el-icon-close" @click="popup = false">
            </div>
        </div>
    </div>
</template>

<script>
import { Header } from 'shared'
import { Banner } from 'shared'
import ContentR from './views/ContentR'
import Footer from './views/Footer'
import { Suspension } from 'shared'
import { Mobile } from 'shared'

export default {
    components: {
        Header,
        Banner,
        ContentR,
        Footer,
        Suspension,
        Mobile
    },
    data() {
        return {
            popup: false,
        }
    },
    created() {
        this.$store.commit('getTaiwan', 'b2b')
        this.$store.dispatch('getBannerZt', 'B2B')
        this.$store.dispatch('getBannerArticle', 'B2B')
        this.$store.commit('getSubmit', '产业数字化')
        this.$store.commit('dataColor', {
            bar0: '#0845a0',
            bar1: '#237bd6',
            line0: '#ff6a04',
            line1: '#fbae08'
        })
        this.$store.commit('getType', 6)
    },
    mounted() {
        setTimeout(() => {
            this.popup = true
        }, 3000)
    }
}
</script>

<style>
#app .right-box .form .btn:hover {
    color: #fff;
    background-color: #0845a0;
    border-color: #0845a0;
}

.company h2::before,
.content-right .platform li:hover,
.move-searchBox,
.report-con .report-title p,
.report-list li a:hover .report-con,
.tsb a:hover span {
    background: #0845a0;
}

.el-menu--horizontal .el-menu .el-menu-item:hover {
    color: #0845a0 !important;
    background: #eee !important;
}
.el-menu--horizontal .el-menu .el-menu-item:hover span {
    color: #0845a0 !important;
}

.content-left .title {
    border-left: 5px solid #0845a0;
}
.content-left .title h2 span {
    color: #0845a0;
    padding: 0 10px;
}

.content-right .right-title a:hover,
.company-title a:hover,
#app .right-box .form .btn,
.text a:hover span,
.content-left .more a,
.project a:hover p,
.report-list li a:hover .report-title p,
.tsb a:hover p,
.mobile-bottom .current,
.mobile-top .current2,
.mobile-submit i,
.backtop:hover,
.code-box:hover {
    color: #0845a0;
}

.popup-bg {
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 1;
}

.popup-box {
    max-width: 960px;
    margin: auto;
    position: relative;
}

.popup-box img {
    width: 100%;
}

.popup-box i {
    font-size: 20px;
    color: #fff;
    background: rgba(0,0,0,.5);
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
    transition: all .3s ease-in-out;
}

.popup-box i:hover {
    background: #0845a0;
}

@media(max-width: 868px) {
  .banner-right .banner-right-m p {
      background: #0845a0;
  }
  .popup-bg {
      bottom: 140px;
  }
}
</style>